import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { USER_INPUT_DEBOUNCE_TIME } from '@modeso/aumico-lib-core-fe';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { I18NextService } from 'angular-i18next';
import { debounceTime } from 'rxjs/operators';

@UntilDestroy()
@Component({
    selector: 'edit-section-title',
    templateUrl: 'edit-section-title.dialog.html',
    styleUrls: ['edit-section-title.dialog.scss'],
})
export class EditSectionTitleComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<EditSectionTitleComponent, string | undefined>,
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private localizedTexts: I18NextService,
        @Inject(MAT_DIALOG_DATA) public data: string,
    ) {
        this.addSvgIcon('interface-delete 1');
    }

    public titleFormControl = new UntypedFormControl('', Validators.required);
    private title: string | undefined;

    ngOnInit(): void {
        if (this.data != null) {
            this.titleFormControl.setValue(this.data);
        }
        this.monitorFormChanges();
    }

    private monitorFormChanges(): void {
        this.titleFormControl.valueChanges
            .pipe(debounceTime(USER_INPUT_DEBOUNCE_TIME), untilDestroyed(this))
            .subscribe((value) => {
                this.title = value;
            });
    }

    private addSvgIcon(name: string): void {
        this.matIconRegistry.addSvgIcon(
            name,
            this.domSanitizer.bypassSecurityTrustResourceUrl(`/assets/icons/${name}.svg`),
        );
    }

    public closeDialog(): void {
        this.dialogRef.close();
    }

    public onSaveClicked(): void {
        this.dialogRef.close(this.title);
    }
}
